import { request } from '/@/axios/request'

// 获取系统设置的套餐列表（需登录）
export function getPlans(params, options) {
  return request('/customer/plan/getPlans', params, options, 'get')
}

// 获取当前用户的套餐信息（需登录）
export function getUserPlan(params, options) {
  return request('/customer/plan/getUserPlan', params, options, 'get')
}

// 选择并开通套餐（需登录）
export function choosePlan(params, options) {
  return request('/customer/plan/choose', params, options, 'post')
}
